export default __webpack_public_path__ + "img/gaSuxDzk.a40398fb.svg";